import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import { Footer, Header } from "./headerFooter";
import Modal from 'react-bootstrap/Modal';
import { Badge } from 'react-bootstrap';
import { useState } from 'react';
import './custom.scss';

function MainPage() {
    const navigate = useNavigate();
    const [showWelcome, setShowWelcome] = useState(() => {
        const shouldShow = localStorage.getItem('showWelcomeModal') === 'true';
        return shouldShow;
    });

    // Function to handle logout
    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    };

    const handleCloseWelcome = () => {
        setShowWelcome(false);
        localStorage.setItem('showWelcomeModal', 'false');
    };

    return (
        <div id='root'>            
            <Header handleLogout={handleLogout} />
            <main className='main-container'>
                <Container>
                    <Modal
                        show={showWelcome}
                        onHide={handleCloseWelcome}
                        backdrop="static"
                        keyboard={false}
                        centered
                        size="lg"
                        >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Καλωσορίσατε στο teachers-app.com!
                                <span className="ms-2 badge red-badge flash-badge">UPDATE - 09 Ιαν 2026</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>
                                Πρόκειται για μια <strong>πιλοτική εφαρμογή</strong> που απευθύνεται σε <strong>αναπληρωτές εκπαιδευτικούς</strong> όλων των κλάδων με στόχο την παροχή εργαλείων πληροφόρησης και ανάλυσης δεδομένων.
                            </p>
                            <p>
                                Μέσα από την εφαρμογή μπορείτε να αναζητήσετε:
                                <ul>
                                <li>Την κατάταξη στους πίνακες (αρχικούς και εκκαθαρισμένους)</li>
                                <li>Στατιστικά για προσλήψεις ανά ειδικότητα, φάση και περιοχή</li>
                                <li>Εκτιμήσεις βάσει <strong>ιστορικών δεδομένων</strong></li>
                                </ul>
                            </p>
                            <p>
                                Τα δεδομένα αντλούνται από τις <strong>επίσημες ανακοινώσεις του Υπουργείου Παιδείας</strong>, ενώ οι τιμές ενοικίων προέρχονται από τον ιστότοπο <a href="https://www.spitogatos.gr/deiktis-timon" target="_blank" rel="noopener noreferrer"><strong>spitogatos.gr</strong></a>.
                            </p>
                            <p>
                                <u>Σημαντικό:</u> Η εφαρμογή <strong>δεν προβλέπει μελλοντικές προσλήψεις</strong>, αλλά βασίζεται αποκλειστικά σε ιστορικά δεδομένα προηγούμενων σχολικών ετών.
                            </p>
                            <p className="update-message">
                                <u><strong>Αλλαγές:</strong></u>
                                    <ul>
                                        <li>(09 Ιαν 2026) <strong>Εκκαθαρισμένοι πίνακες ΑΣΕΠ</strong> για όλες τις προκηρύξεις <strong>γενικής</strong> και <strong>ειδικής</strong> μετά τις προσλήψεις που έγιναν στις <strong>05 Ιανουαρίου 2026</strong>.</li>
                                        <li>(09 Ιαν 2026) Προσθήκη των προσλήψεων της <strong>Δ' φάσης 2025/26</strong> στη σελίδα <strong>Ιστορικά δεδομένα προσλήψεων</strong>.</li>
                                        <li>(09 Ιαν 2026) Ανανέωση των σελίδων <strong>Αριθμός προσλήψεων ανά ημερομηνία πρόσληψης</strong> και <strong>Έλεγχος περιοχών βάσει θέσης πίνακα</strong> μετά τις προσλήψεις της Δ' φάσης 2025/26.</li>
                                    </ul>
                                Τα αποτελέσματα των προκηρύξεων 1ΕΑ/2025, 2ΕΑ/2025 και 3ΕΑ/2025 αναφέρονται στους <strong>ΠΡΟΣΩΡΙΝΟΥΣ</strong> πίνακες που εκδόθηκαν από τον ΑΣΕΠ και <strong>ΟΧΙ</strong> στους τελικούς που θα προκύψουν μετά από τις ενστάσεις.<br/><br/>
                                Οι εκκαθαρίσεις πραγματοποιούνται: 
                                <ul>
                                    <li>με βάσει τους <strong>ΠΡΟΣΩΡΙΝΟΥΣ</strong> πίνακες διορισμών όπως αυτοί ανακοινώθηκαν από το Υπουργείο Παιδείας</li>
                                    <li>λαμβάνοντας υπόψη τα στοιχεία <strong>Επώνυμο</strong>, <strong>Όνομα</strong>, <strong>Πατρώνυμο</strong> και <strong>Κλάδο Πρόσληψης</strong></li>
                                </ul>
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handleCloseWelcome}>
                            Έναρξη
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    
                    <Accordion>
                        <Accordion.Item eventKey='0'>
                            <Accordion.Header>
                                Αριθμός προσλήψεων ανά ημερομηνία πρόσληψης
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Επιλέγοντας το <strong>Έτος</strong>, την <strong>Ειδικότητα</strong> και την <strong>Περιοχή Προτίμησης</strong>, ο εκπαιδευτικός έχει τη δυνατότητα να δει άμεσα τον <strong>Συνολικό αριθμό προσλήψεων</strong> ανά ημερομηνία πρόσληψης για την επιλεγμένη σχολική χρονιά. Επίσης, μπορεί εύκολα να δει τη θέση του πρώτου και τελευταίου προσληφθέντα ανά ημερομηνία πρόσληψης.<br /><strong>Διευκρίνιση: </strong>Οι θέσεις του πρώτου και τελευταίου αναφέρονται στους αρχικούς πίνακες και όχι τους εκκαθαρισμένους.
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/ranking-per-state')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='1'>
                            <Accordion.Header>
                                    Έλεγχος περιοχών βάσει θέσης πίνακα
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ο εκπαιδευτικός εισάγει τη θέση του βάσει του αρχικού πίνακα (όχι του εκκαθαρισμένου), τη σχολική χρονιά που τον ενδιαφέρει, την ειδικότητα του και την φάση προσλήψεων που τον ενδιαφέρει. Το αποτέλεσμα που προκύπτει είναι όλες οι περιοχές που θα μπορούσε να είχε προσληφθεί τη συγκεκριμένη σχολική χρονιά και φάση προσλήψεων βάσει της θέσης του.<br />
                                <strong>Παράδειγμα αποτελέσματος: </strong><br />
                                Έστω ότι ο εκπαιδευτικός εισάγει: 2023-2024, ΠΕ70, 1500, 2023-09-01<br />
                                Το αποτέλεσμα που προκύπτει είναι το παρακάτω:
                                <ul>
                                    <li>ΦΛΩΡΙΝΑΣ (Π.Ε.)</li>
                                    <li>Πρώτος στον πίνακα: 529</li>
                                    <li>Τελευταίος στον πίνακα: 1619</li>
                                    <li>Συνολικές προσλήψεις: 3</li>
                                </ul>
                                Άρα ο εκπαιδευτικός με θέση 1500 θα μπορούσε να έχει προσληφθεί στη Φλώρινα καθώς ο τελευταίος στη λίστα των προσλήψεων είχε θέση 1619.<br /><br />
                                <strong>Διευκρίνιση: </strong>Ο εκπαιδευτικός θα πρέπει να εισάγει τη θέση βάσει του αρχικού πίνακα και όχι των εκκαθαρισμένων.
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/ranking-per-score')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='2'>
                            <Accordion.Header>
                                Εύρεση θέσης πίνακα
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ο εκπαιδευτικός εισάγει τα παρακάτω στοιχεία:
                                <ul>
                                    <li><strong>Προκήρυξη διαγωνισμού:</strong> Η ονομασία του διαγωνισμού από τον οποίο προκύπτει ο πίνακας προσλήψεων (π.χ. 1ΓΕ/2023)</li>
                                    <li><strong>Επώνυμο</strong> (υποχρεωτικό πεδίο)</li>
                                    <li><strong>Όνομα</strong> (προαιρετικό πεδίο)</li>
                                    <li><strong>Πατρώνυμο</strong> (προαιρετικό πεδίο)</li>
                                    {/* <li><strong>Α.Δ.Τ.</strong> (προαιρετικό πεδίο): ο Α.Δ.Τ. που είναι δηλωμένος στην συγκεκριμένη προκήρυξη</li> */}
                                    <li><strong>Είδος πίνακα</strong>: Αρχικός πίνακας ή Εκκαθαρισμένος μετά τους τελευταίους διορισμούς</li>
                                </ul>
                                Το αποτέλεσμα της αναζήτησης είναι η θέση του εκπαιδευτικού στον πίνακα που έχει επιλέξει.
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/ranking-personal-details')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='3'>
                            <Accordion.Header>
                                Ημερομηνία πρόσληψης βάσει σειράς πίνακα
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ο εκπαιδευτικός εισάγει την <strong>σχολική χρονιά</strong> που τον ενδιαφέρει, την <strong>ειδικότητά</strong> του και την <strong>θέση</strong> του στον αρχικό πίνακα (όχι εκκαθαρισμένο) και ενημερώνεται σχετικά με την ημερομηνία πρόσληψης.<br />
                                Πρόκειται για ένα εργαλείο που απευθύνεται κατά βάση σε αναπληρωτές εκπαιδευτικούς που δεν έχουν εργαστεί στο παρελθόν και θα ήθελαν να έχουν μία εκτίμηση σχετικά με την ενδεχόμενη ημερομηνία προσληψής τους, λαμβάνοντας υπόψη ιστορικά δεδομένα. 
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/appointment-date')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='4'>
                            <Accordion.Header>
                                Συνολικός αριθμός εκπαιδευτικών που προηγούνται
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ο εκπαιδευτικός εισάγει τη <strong>σχολική χρονιά</strong> που τον ενδιαφέρει, την <strong>ειδικότητά</strong> του, τη <strong>θέση</strong> του στον αρχικό πίνακα (όχι εκκαθαρισμένο), την <strong>περιοχή προτίμησής</strong> και αν αναφέρεται στον πίνακα <strong>ειδικής αγωγής</strong> ή όχι.<br />
                                Ενημερώνεται για όλες τις φάσεις πρόσληψης σχετικά με τον συνολικό αριθμό προσλήψεων καθώς και για τον αριθμό των ατόμων που προηγούνται.<br />
                                <strong>Παράδειγμα αποτελέσματος: </strong><br />
                                Έστω ότι ο εκπαιδευτικός εισάγει: 2023-2024, ΠΕ02, 1500, Α' ΕΒΡΟΥ (Δ.Ε.), Ειδική αγωγή: ΟΧΙ<br />
                                Το αποτέλεσμα που προκύπτει είναι το παρακάτω:
                                <ul>
                                    <li>2023-09-01</li>
                                    <li>Άτομα πριν από μένα: 14</li>
                                    <li>Συνολικές προσλήψεις: 23</li>
                                </ul>
                                Άρα, κατά την φάση προσλήψεων που έγινε στις 01/09/2023 προσλήφθηκαν 23 άτομα στην γενική από τα οποία τα 14 είχαν καλύτερη θέση από τον ενδιαφερόμενο εκπαιδευτικό.
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/ranking-above-me')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='5'>
                            <Accordion.Header>
                                Ιστορικά δεδομένα προσλήψεων
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ιστορικά δεδομένα προσλήψεων προηγούμενων ετών ανά ημερομηνία πρόσληψης και ανά περιοχή
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/historical-data')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='6'>
                            <Accordion.Header
                            >
                                Ιστορικά δεδομένα διορισμών  {/*<span className="badge green-badge  ms-2"><i className="bi bi-star me-1"></i>Νέο</span>*/}
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Ιστορικά δεδομένα διορισμών προηγούμενων ετών ανά έτος διορισμού και ανά περιοχή
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/historical-data-appointments')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='7'>
                            <Accordion.Header>
                                Μοριοδότηση σχολικών μονάδων {/*<span className="badge green-badge  ms-2"><i className="bi bi-star me-1"></i>Νέο</span>*/}
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Μοριοδότηση σχολικών μονάδων ανά περιοχή και είδος εκπαίδευσης (εύρεση δυσπρόσιτων σχολείων)
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/non-reachable-places')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='8'>
                            <Accordion.Header>
                                Μεταθέσεις εκπαιδευτικών
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                Δεδομένα μεταθέσεων εκπαιδευτικών τρέχοντος έτους και προηγούμενων ετών
                                <div>
                                    <Button className="mt-2" variant="secondary" onClick={() => navigate('/transfers')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey='9'>
                            <Accordion.Header>
                                Τιμές ενοικίων
                            </Accordion.Header>
                            <Accordion.Body className='custom-accordion-body'>
                                <div>
                                    Μέσος όρος τιμών ενοικίων ανά νομό (Σύγκριση των πρώτων τριμήνων των ετών 2023-2025)<br/>
                                    <p><i>Πηγή δεδομένων: <strong><a href='https://www.spitogatos.gr/deiktis-timon' target="_blank" rel="noopener noreferrer">spitogatos.gr</a></strong></i></p>
                                </div>
                                <div>
                                    <Button variant="secondary" onClick={() => navigate('/rent-prices')}>Είσοδος</Button>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Container>
            </main>
            <Footer />
        </div>
    );
}

export default MainPage;